/**
 * Shopify.actions overrides (apps call these):
 * - updateCart: emit its cart events from the purolabs cart drawer, which re-renders from them.
 * - openCart: open the purolabs cart drawer (go to /cart when the page has none).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart?.configure({
    eventTarget: () => document.querySelector('pl-cart-drawer') ?? document,
  });

  actions.openCart?.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('pl-cart-drawer');
      if (drawer) await customElements.whenDefined('pl-cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = window.Theme?.routes?.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
